import { FC, useEffect, useRef } from "react";
import Select, { GroupBase, OptionsOrGroups, PropsValue } from "react-select";
import {format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { QueryStateActions } from "src/pages/dashboard/types";
import { CaseFilterProps } from "./types";

const TableFilters: FC<CaseFilterProps> = ({ state, dropdownData, inputPlaceholder, dispatch, handleSearchWithQueryParam, onClearButtonClicked, onStatusChange }): JSX.Element => {
  const startDateRef = useRef<DatePicker | null>(null)
  const endDateRef = useRef<DatePicker | null>(null)

  useEffect(() => {
    document.addEventListener("touchend", () => {
      if (startDateRef.current) {
        if (startDateRef.current.isCalendarOpen()) startDateRef.current.setOpen(false)
      }
      if (endDateRef.current) {
        if (endDateRef.current.isCalendarOpen()) endDateRef.current.setOpen(false)
      }
    });
    return () => document.removeEventListener("touchend", () => {
      if (startDateRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (startDateRef.current.isCalendarOpen()) startDateRef.current.setOpen(false)
      }
      if (endDateRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (endDateRef.current.isCalendarOpen()) endDateRef.current.setOpen(false)
      }
    });
  }, []);
  const handleDateFromChange = (date: Date | null): void => {
    dispatch({
      type: QueryStateActions.CHANGE_FROM_DATE,
      payload: date ? format(date, "yyyy-MM-dd") : "",
    });
  };

  const handleDateToChange = (date: Date | null) => {
    dispatch({
      type: QueryStateActions.CHANGE_TO_DATE,
      payload: date ? format(date, "yyyy-MM-dd") : "",
    });
  };


  const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: QueryStateActions.CHANGE_SEARCH_QUERY,
      payload: e.target.value
    });
  };

  const onEnterPress  = (e:React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchWithQueryParam()
    }
  }

  return (
    <div className="row g-2">
      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
        <div className="row g-2">
          <div className="col-12 col-sm-12 col-md-4">
            <Select
                options={dropdownData as unknown as OptionsOrGroups<string | boolean, GroupBase<string | boolean>>}
                noOptionsMessage={() => ""}
                onChange={(val) => {
                  const selectedValue = val as unknown as { label: string; value: string | boolean };
                  (typeof selectedValue.value === "boolean") ?
                      dispatch({
                        type: QueryStateActions.CHANGE_CASE_STATUS,
                        payload: selectedValue.value,
                      }) :
                      dispatch({
                        type: QueryStateActions.CHANGE_CATEGORY_TYPE,
                        payload: selectedValue.value,
                      });
                  onStatusChange(selectedValue.label);
                }}
                isSearchable={false}
                value={((openValue: string | boolean) => {
                  const data = dropdownData.find(singleStatus =>
                      singleStatus.value === openValue
                  );
                  if (data) return data as unknown as PropsValue<string | boolean>;
                })(typeof state.open === "boolean" ? state.open : state.category_type)}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 position-relative">
            <DatePicker
              selected={state.date_from ? parse(state.date_from, "yyyy-MM-dd", new Date()) : null}
              onChange={handleDateFromChange}
              className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
              placeholderText="mm/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              customInput={
                <ReactInputMask mask="99/99/9999">
                  {(inputProps: {}) => <input {...inputProps} />}
                </ReactInputMask>
              }
              maxDate={state.date_to ? new Date(state.date_to) : undefined}
            />
            <i
              className="bi bi-calendar position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            ></i>
          </div>
          <div className="col-12 col-sm-6 col-md-4 position-relative">
            <DatePicker
              selected={state.date_to ? parse(state.date_to, "yyyy-MM-dd", new Date()) : null}
              onChange={handleDateToChange}
              dateFormat="MM/dd/yyyy"
              className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
              placeholderText="mm/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              customInput={
                <ReactInputMask mask="99/99/9999">
                  {(inputProps: {}) => <input {...inputProps} />}
                </ReactInputMask>
              }
              minDate={state.date_from ? new Date(state.date_from) : undefined}
            />
            <i
              className="bi bi-calendar position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            ></i>
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
        <div className="row g-2">
          <div className="col-12 col-sm-12 col-md-7 col-lg-8">
            <input type="text" onChange={handleSearchQueryChange} value={state.search_query}
                   placeholder={inputPlaceholder} className="form-control rounded-1" onKeyDown={onEnterPress}/>
          </div>

          <div className="col-12 col-sm-12 col-md-5 col-lg-4">
            <div className="row g-2">
              <div className="col-6">
                <button type="button" onClick={onClearButtonClicked}
                        className="btn btn-outline-secondary w-100 rounded-0">
                  Clear
                </button>
              </div>
              <div className="col-6">
                <button type="button" onClick={() => {
                  dispatch({type: QueryStateActions.CHANGE_PAGE, payload: 1,});
                  handleSearchWithQueryParam({...state, page: 1});
                }} className="btn btn-primary w-100 rounded-0">
                  <i className="fas fa-search"></i> Find
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
